import ApiService from './api.service';
import { QuestionDTO } from '../models/QuestionDTO';
import { ProInclusionDTO } from '../models/ProInclusionDTO';
import { ProQuestionDTO } from '@/models/ProQuestionDTO';
import LocalStoreService from '@/store/local.store';

export default class QuestionService {

  /**
   * Get the questions configuration
   * @param {boolean} alternativeQuestionnaire - Flag to get configuration for alternative questionnaire
   * @returns {QuestionDTO[]} a list of QuestionDTO object
   */
  public static async fetchQuestions(alternativeQuestionnaire: boolean): Promise<QuestionDTO[]> {
    let url = `${process.env.VUE_APP_PUBLIC_ROOT_API}/questions`;
    if (alternativeQuestionnaire) {
      url = url + `/alternatives`;
    }
    return await ApiService.get(url)
      .then((response: any) => {
        return response.data as QuestionDTO[];
      });
  }

  /**
   * Get the questions configuration for a pro user
   * @param {number} partId - The participant ID
   * @param {boolean} alternativeQuestionnaire - Flag to get configuration for alternative questionnaire
   * @returns {ProQuestionDTO} a list of QuestionDTO object and the pro inclusion
   */
  public static async fetchProQuestions(partId: number, alternativeQuestionnaire: boolean): Promise<ProQuestionDTO> {
    let url = `${process.env.VUE_APP_PUBLIC_ROOT_API}/questions/${partId}`;
    if (alternativeQuestionnaire) {
      url = url + `/alternatives`;
    }

    return await ApiService.get(url)
      .then((response: any) => {
        return response.data as ProQuestionDTO;
      });
  }


  /**
   * Save inclusion data depending on the answered questions
   * @param {QuestionDTO[]} questions The list of questions to save
   * @param {number} partId The participant ID
   * @param {boolean} isRefusal Flag to indicate the type of questionnaire we are saving
   * (true for the alternative questionnaire)
   */
  public static async postQuestions(
    questions: QuestionDTO[],
    partId: number,
    isRefusal: boolean,
    isSimpleConsent: boolean,
    isExclusion: boolean,
    isInclusion: boolean,
    participantInclusionType: string = '') {
    await ApiService.post(`${process.env.VUE_APP_PUBLIC_ROOT_API}/questions`,
      {
        partId,
        questions,
        isRefusal,
        participantInclusionType,
        isSimpleConsent: !isRefusal && !isExclusion && isInclusion && isSimpleConsent,
      })
      // tslint:disable-next-line: no-empty
      .then((response: any) => {});
  }

  /**
   * Save inclusion data depending on the answered questions (for pro user)
   * @param {QuestionDTO[]} questions The list of questions to save
   * @param {number} partId The participant ID
   * @param {boolean} isRefusal Flag to indicate the type of questionnaire we are saving
   * (true for the alternative questionnaire)
   * @param {ProInclusionDTO} proInclusion contains the data such as weight, height, consultation type..
   */
  public static async postProQuestions(
    questions: QuestionDTO[], partId: number, isRefusal: boolean,
    proInclusion: ProInclusionDTO|null) {
      await ApiService.post(`${process.env.VUE_APP_PUBLIC_ROOT_API}/questions/${partId}`,
        {
          partId,
          questions,
          isRefusal,
          proInclusion,
          isSimpleConsent: false,
        })
        // tslint:disable-next-line: no-empty
        .then((response: any) => { });
  }
}
